// src/components/pipeline/LeadCardMenu.jsx
// The ⋮ menu on a pipeline card — the drawer's negative actions (Mark as
// Lost, Delete Lead) without opening the card. Shared by the Board and List
// views. The dropdown is position:fixed so the board's horizontal scroller
// can't clip it; pointer events are stopped so opening it never drags or
// opens the card.
import { useState } from "react";
import { MoreVertical, Ban, Trash2 } from "lucide-react";

const stop = (e) => e.stopPropagation();

export default function LeadCardMenu({ lead, onMarkLost, onDelete }) {
  const [pos, setPos] = useState(null); // {top, right} while open

  if (!onMarkLost && !onDelete) return null;

  const toggle = (e) => {
    e.stopPropagation();
    if (pos) {
      setPos(null);
      return;
    }
    const r = e.currentTarget.getBoundingClientRect();
    setPos({ top: r.bottom + 4, right: Math.max(8, window.innerWidth - r.right) });
  };

  const run = (fn) => (e) => {
    e.stopPropagation();
    setPos(null);
    fn(lead);
  };

  return (
    <>
      <button
        type="button"
        aria-label="More actions"
        title="More actions"
        onPointerDown={stop}
        onClick={toggle}
        className="text-slate-400 hover:text-slate-700 p-0.5 rounded flex-shrink-0"
      >
        <MoreVertical size={15} />
      </button>
      {pos && (
        <>
          <div
            className="fixed inset-0 z-30"
            onPointerDown={stop}
            onClick={(e) => {
              e.stopPropagation();
              setPos(null);
            }}
          />
          <div
            className="fixed z-40 w-44 bg-white rounded-lg shadow-xl border border-slate-200 py-1"
            style={{ top: pos.top, right: pos.right }}
            onPointerDown={stop}
          >
            {onMarkLost && lead.status === "active" && (
              <button
                type="button"
                onClick={run(onMarkLost)}
                className="w-full text-left px-3 py-2 text-sm text-slate-700 hover:bg-slate-50 flex items-center gap-2"
              >
                <Ban size={14} /> Mark as Lost
              </button>
            )}
            {onDelete && (
              <button
                type="button"
                onClick={run(onDelete)}
                className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center gap-2"
              >
                <Trash2 size={14} /> Delete Lead
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
}
